import React from "react"
import { graphql } from "gatsby"
import { MDXRenderer } from "gatsby-plugin-mdx"
import { MDXProvider } from '@mdx-js/react'
import { css } from "@emotion/core"
import { H1, H2, H3, H4, H5, H6, HR, BlockQuote, LI, OL, Strong, EM, Pre, Code, P} from "../components/markdown-elements"

import Layout from "../components/layout"
import TableOfContents from "../components/table-of-contents"
import SEO from "../components/seo"

const leftRightGrid = css`
  display: grid;
  grid-template-areas: "left left left right";
  grid-column-gap: 100px;
`

const components = {
  h1: props => <H1 {...props} />,
  h2: props => <H2 {...props} />,
  h3: props => <H3 {...props} />,
  h4: props => <H4 {...props} />,
  h5: props => <H5 {...props} />,
  h6: props => <H6 {...props} />,
  hr: props => <HR {...props} />,
  blockquote: props => <BlockQuote {...props} />,
  li: props => <LI {...props} />,
  ol: props => <OL {...props} />,
  strong: props => <Strong {...props} />,
  em: props => <EM {...props} />,
  pre: props => <Pre {...props} />,
  code: props => <Code {...props} />,
  p: props => <P {...props} />,
  // p: props => <P {...props} />,
}

export default function BlogPost({ data }) {
  const post = data.mdx
  return (
    <MDXProvider components={components}>
      <Layout>
      <SEO title={post.frontmatter.title} description={post.frontmatter.description} />
        <div css={leftRightGrid}>
          <aside
            css={css`
            grid-area: right;
            `}
            >
            <TableOfContents tableOfContents={data.mdx.tableOfContents} />
          </aside>
          <article
            css={css`
            grid-area: left;
            `}
            >
            <h1>{post.frontmatter.title}</h1>
            <MDXRenderer>{post.body}</MDXRenderer>
          </article>
        </div>
      </Layout>
    </MDXProvider>
  )
}

export const query = graphql`
  query($slug: String!) {
    mdx(fields: { slug: { eq: $slug } }) {
      frontmatter {
        title
        date(formatString: "YYYY MMMM Do")
      }
      body
      excerpt
      tableOfContents(maxDepth: 4)
      timeToRead
      fields {
        slug
      }
    }
  }
`
